/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, October 5th 2022, 12:53:14 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { FormConfiguration } from "lib/schemas";
import { useFormBuilderStore, currentFormSelector } from "form-builder/stores";
import { useFormsAPI } from "form-builder/services";
import { TranslatableInputWrapper } from "translation/components";
import { EditToggler } from "ui-widgets";

export const FormBuilderTitle = () => {
  const { useAPIMutateForm } = useFormsAPI();
  const { patchData } = useAPIMutateForm();
  const currentFormConfiguration = useFormBuilderStore(currentFormSelector);
  const setCurrentForm = useFormBuilderStore((state) => state.setCurrentForm);

  const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) =>
    patchData({
      apiPathParams: [currentFormConfiguration.id],
      body: JSON.stringify({ title: event.target.value }),
      setValidAPIResponse: (mutatedForm: FormConfiguration) => {
        setCurrentForm(mutatedForm);
      },
    });

  const handleTranslationChange = (translatedFieldKey: string, translatedValue: string) =>
    patchData({
      apiPathParams: [currentFormConfiguration.id],
      body: JSON.stringify({ [translatedFieldKey]: translatedValue }),
      setValidAPIResponse: (mutatedForm: FormConfiguration) => {
        setCurrentForm(mutatedForm);
      },
    });

  return (
    <EditToggler
      renderEditComponent={({ setValueInputRef }) => (
        <TranslatableInputWrapper<FormConfiguration>
          fieldKey="title"
          fieldValue={currentFormConfiguration.title}
          getTranslatedValue={(key) => currentFormConfiguration[key]}
          setTranslatedValue={handleTranslationChange}
        >
          <TextField
            onBlur={handleOnBlur}
            inputRef={setValueInputRef}
            defaultValue={currentFormConfiguration.title}
            fullWidth
            variant="standard"
          />
        </TranslatableInputWrapper>
      )}
    >
      {({ toggleEditMode, editIcon }) => (
        <Stack direction="row" spacing={2}>
          <Typography onClick={toggleEditMode} variant="h4">
            {currentFormConfiguration.title}
          </Typography>
          {editIcon}
        </Stack>
      )}
    </EditToggler>
  );
};
